export enum CommunicationCampaignRecipient {
  FANGROUP = 'fangroup',
  PARTIAL_FANGROUP = 'partial_fangroup',
  WAITING_LIST = 'waitinglist',
  BADGE = 'badge',
  WAITING_LIST_NOT_DISTRIBUTED = 'waitinglist_not_distributed',
  WAITING_LIST_DISTRIBUTED_NOT_ACCEPTED = 'waitinglist_distributed_not_accepted',
  WAITING_LIST_DISTRIBUTED = 'waitinglist_distributed',
  WAITING_LIST_DISTRIBUTED_ACCEPTED = 'waitinglist_distributed_accepted',
}
